import { routesMap } from '../../routes/routesMap';
import HeroSection from '../../components/conduct-risk/HeroSection';
import ModuleCard from '../../components/ui/ModuleCard';
import { CONDUCT_RISK_CARDS } from './conductRiskCards';

const ConductRiskHomePage = () => {
  return (
    <div className="flex flex-col bg-gray-50">
      <HeroSection
        title="Conduct Risk"
        description="Monitora e gestisci i rischi di condotta e conformità."
        breadcrumbLinks={[
          { url: routesMap.HOME_PAGE, title: 'Home' },
          { url: '#', title: 'Conduct Risk' },
        ]}
      />

      <div className="flex-1 px-8 lg:px-16 py-12 w-full">
        <h2 className="text-2xl font-bold mb-2 font-heading" style={{ color: '#1B365D' }}>
          I tuoi strumenti
        </h2>
        <p className="text-gray-500 mb-8 font-paragraph">
          Seleziona la sezione a cui vuoi accedere.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {CONDUCT_RISK_CARDS.map((card, i) => (
            <ModuleCard key={i} {...card} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConductRiskHomePage;
